// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"850":"4cbbc423","933":"b40bbc8a"}[chunkId] + ".chunk.js";
};